/**
 * Funzione che dato il nome di un file, in questo caso stiamo parlando di assets, controlla se esiste una sua preview.
 * Nel backend le preview sono salvate con il nome file più l' estensione .jpg
 * @param params
 * @returns {Promise<*>}
 */
export const fetchAssetPreviewImage = async (params) => {
    const { name } = params

    if(!name) return false

    const url = name + '.jpg'

    try {
        const result = await checkImageExists(url)

        if(!result) {
            const lowerName = name.toLowerCase();
            const isImage = lowerName.endsWith('.jpg') || lowerName.endsWith('.png');

            if (!isImage) {
                return false
            }
            return name
        }

        return url
    } catch (error) {
        console.error(error)
        return false
    }
}

/**
 * Funzione che fa una get di un file, per controllare se esiste
 * @param url
 * @returns {Promise<boolean | unknown>}
 */
// export const checkImageExists = (url) => {
//     // Prima prova con cors normale
//     return fetch(url, { method: 'HEAD' })
//         .then(response => {
//             // console.log('Fetch response status:', response.status);
//             return response.ok; // true se status 200-299
//         })
//         .catch(error => {
//             // console.warn('Fetch failed, trying Image approach:', error);
//
//             // Fallback alla funzione Image
//             return new Promise((resolve) => {
//                 const img = new Image();
//                 let resolved = false;
//
//                 const timeout = setTimeout(() => {
//                     if (!resolved) {
//                         resolved = true;
//                         resolve(false);
//                     }
//                 }, 3000);
//
//                 img.onload = () => {
//                     if (!resolved) {
//                         resolved = true;
//                         clearTimeout(timeout);
//                         resolve(true);
//                     }
//                 };
//
//                 img.onerror = () => {
//                     if (!resolved) {
//                         resolved = true;
//                         clearTimeout(timeout);
//                         resolve(false);
//                     }
//                 };
//
//                 img.src = url;
//             });
//         });
// }

export const checkImageExists = (url) => {
    return new Promise((resolve) => {
        // Funzione helper per testare l'immagine
        const testImage = (imageUrl, useCors = false) => {
            return new Promise((resolveImg) => {
                const img = new Image();
                let resolved = false;

                const timeout = setTimeout(() => {
                    if (!resolved) {
                        resolved = true;
                        resolveImg(false);
                    }
                }, 3000);

                img.onload = () => {
                    if (!resolved) {
                        resolved = true;
                        clearTimeout(timeout);
                        // Verifica che l'immagine abbia dimensioni valide
                        resolveImg(img.naturalWidth > 0 && img.naturalHeight > 0);
                    }
                };

                img.onerror = () => {
                    if (!resolved) {
                        resolved = true;
                        clearTimeout(timeout);
                        resolveImg(false);
                    }
                };

                if (useCors) {
                    img.crossOrigin = 'anonymous';
                }

                img.src = imageUrl;
            });
        };

        // Strategia a cascata: fetch -> image -> image con CORS
        const strategies = [
            // Strategia 1: Fetch HEAD (con cache: 'no-store' per bypassare la cache di Chrome)
            () => fetch(url, { method: 'HEAD', mode: 'cors', cache: 'no-store' })
                .then(response => response.ok)
                .catch(() => false),

            // Strategia 2: Image normale
            () => testImage(url, false),

            // Strategia 3: Image con CORS
            () => testImage(url, true)
        ];

        // Esegui le strategie in sequenza
        const tryStrategies = async () => {
            for (let i = 0; i < strategies.length; i++) {
                try {
                    const result = await strategies[i]();
                    if (result) {
                        resolve(true);
                        return;
                    }
                } catch (error) {
                    console.warn(`Strategy ${i + 1} failed:`, error);
                }
            }
            // Se tutte le strategie falliscono, l'immagine non esiste
            resolve(false);
        };

        tryStrategies();
    });
};